var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-wrapper"},[_c('c-header'),_c('div',{staticClass:"c-container",class:{
      'c-sidebar--hide': _vm.isCollapse,
    }},[_c('Sidebar'),_c('div',{staticClass:"c-container__content"},[_c('Main')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }